import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../common/Button';

export function HeroSection() {
  const { signIn } = useAuth();

  return (
    <section className="py-24 px-6">
      <div className="max-w-4xl mx-auto text-center">
        <p className="font-mono text-sm uppercase tracking-widest text-action mb-6">
          R&D Evaluation Platform
        </p>
        <h1 className="text-5xl md:text-6xl font-bold text-white tracking-tight leading-tight mb-6">
          Transform Ideas Into
          <br />
          <span className="text-action">Strategic Investments</span>
        </h1>
        <p className="text-xl text-wolf-300 max-w-2xl mx-auto mb-10">
          AI-powered evaluation framework combining Heilmeier Catechism, WAR Analysis,
          and Skunk Works principles to identify breakthrough R&D opportunities.
        </p>
        <div className="flex gap-4 justify-center">
          <Button size="lg" onClick={signIn}>
            Sign In with Microsoft
          </Button>
        </div>
      </div>
    </section>
  );
}
